/**
 * Display helpers for the progress payloads.
 *
 * The one rule they exist to enforce: `mastery` is 0–1 OR null, and null means
 * "never answered here". It must never reach the screen as 0% or 50% — a fresh
 * mastery row starts at 0.5, which is exactly the number a careless `?? 0.5`
 * would invent. formatMastery() returns null so the caller has to leave the
 * label out entirely.
 */

/** Bar widths come from the API; clamp so bad data can't overflow the track. */
export function clampPercent(percent: number): number {
  if (!Number.isFinite(percent)) {
    return 0;
  }

  return Math.min(100, Math.max(0, percent));
}

/** "72%" — the API sends one decimal, the UI shows whole percent. */
export function formatPercent(percent: number): string {
  return `${Math.round(clampPercent(percent))}%`;
}

/** A done/total pair as a percentage. Nothing to do is 0%, never NaN. */
export function ratioPercent(done: number, total: number): number {
  if (total <= 0) {
    return 0;
  }

  return clampPercent((done * 100) / total);
}

/**
 * Mastery as a label, or null when the student has not started.
 *
 * @param mastery 0–1, or null
 */
export function formatMastery(mastery: number | null): string | null {
  if (mastery === null) {
    return null;
  }

  return `${Math.round(clampPercent(mastery * 100))}%`;
}

/** "8 de 24 tópicos" — the same sentence on the Início and Matéria headers. */
export function topicsLabel(done: number, total: number): string {
  return `${done} de ${total} ${total === 1 ? "tópico" : "tópicos"}`;
}
